import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import './CookieConsent.css';

const CONSENT_KEY = 'chucks-cookie-consent';

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    setShowBanner(localStorage.getItem(CONSENT_KEY) !== 'accepted');
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner" role="region" aria-label="Cookie consent">
      <div className="cookie-inner">
        <p className="cookie-text">
          &#x1F36A; <strong>Cookies.</strong> California law requires us to tell you this site uses
          cookies for authentication. They are login cookies. They do not track you across the
          internet or sell your data to anyone. They just keep you logged in so you can see the
          menu. We would not have mentioned them at all, but here we are.
          <Link to="/privacy" className="cookie-link">
            Privacy Policy
          </Link>
        </p>
        <button type="button" className="cookie-btn" onClick={accept}>
          Fine, Whatever
        </button>
      </div>
    </div>
  );
}
